import {
  Divider
} from '@mui/material'

import { useContext, useEffect } from 'react'

// Components
import Bag from 'src/components/common/Bag'
import Equipment from 'src/components/common/Equipment'

// Context
import { InventoryDataContext } from 'src/store/inventory/Store'
import { setEquippedStats } from 'src/store/stats/actions'
import { ItemDataContext } from 'src/store/items/Store'
import { StatsDispatchContext } from 'src/store/stats/Store'


const Inventory = () => {
  const { items } = useContext(ItemDataContext)
  const { dispatchStats } = useContext(StatsDispatchContext)
  const { inventory } = useContext(InventoryDataContext)

  useEffect(() => {
    setEquippedStats(dispatchStats, items, inventory)
  }, [inventory.equipped])

  // development build logs
  useEffect(() => {
    if (process.env.REACT_APP_BENCHMARK === 'true') { console.log('Inventory mounted') }
    return process.env.REACT_APP_BENCHMARK === 'true' ? () => console.log('Inventory unmounted') : () => { }
  }, [])

  useEffect(() => {
    if (process.env.REACT_APP_BENCHMARK === 'true') { console.log('Inventory rendered') }
  })

  return (
    <>
      <Bag />
      <Divider sx={{ marginY: 2 }} />
      <Equipment />
    </>
  )
}

export default Inventory
